import DataGridComponent from 'Utils/Helpers/DataGridComponent';
import TotalAppointmets from './components/appointments/Total';
import SectionAppointmets from './components/appointments/Section';
import Logs from './components/appointments/Logs';

export default function AppLanding({ data, logs, withSection, noName, patient }) {
    function Status({ text, className}) {
        return (
            <div className={`mt-4 text-center ${className ? className : ''}`}>
                <small>{text}</small>
            </div>
        )
    }
    return (
        <div className='main-appointment-list'>
            {
                !patient
                ? (data && logs)
                    ? (data.length === 0 && logs.length === 0)
                        ? <Status text={"اطلاعاتی برای نمایش وجود ندارد"} />
                        : (data.length === 0 && logs.length !== 0)
                            ? <>
                                <Status text={"نوبتی برای امروز ثبت نشده است"} />
                                <Logs items={logs} />
                            </>
                            : (data.length !== 0 && logs.length === 0)
                                ? <>
                                    {
                                        withSection
                                        ? <SectionAppointmets data={data} noName={noName} patient={patient} logs={logs}/>
                                        : <TotalAppointmets data={data} noName={noName} patient={patient} />
                                    }
                                    <Status text={"سابقه نوبتی برای امروز ثبت نشده است"} className='pb-2 mb-4'/>
                                </>
                                : <>
                                    {
                                        withSection
                                        ? <SectionAppointmets data={data} noName={noName} patient={patient} logs={logs}/>
                                        : <TotalAppointmets data={data} noName={noName} patient={patient} />
                                    }
                                    <Logs items={logs} />
                                </>
                    : <Status text={"لطفا کمی صبر کنید ..."} />
                : data
                    ? data.length !== 0
                        ? <>
                            {
                                withSection
                                ? <SectionAppointmets data={data} noName={noName} patient={patient} logs={logs}/>
                                : <TotalAppointmets data={data} noName={noName} patient={patient} />
                            }
                        </>
                        : <Status text={"نوبتی برای بیمار ثبت نشده است"} />
                    : <Status text={"لطفا کمی صبر کنید ..."} />
            }
        </div>
    );
}